import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { Box, Typography } from '@mui/material';
import TourGrid from '../TourGrid';
import { asyncGetPublicOngoingTours } from "../../../../store/Vanlifer/Community/discoverTourSlice";

export default function OngoingToursContainer() {
    const dispatch = useAppDispatch();
    const ongoingTours = useAppSelector(state => state.discoverTours.ongoingTours);
    const loading = useAppSelector(state => state.discoverTours.loading);
    const error = useAppSelector(state => state.discoverTours.error);
    const isAuthenticated = useAppSelector(state => state.login.isAuthenticated);

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(asyncGetPublicOngoingTours());
        }
    }, [dispatch, isAuthenticated]);

    if (error) return <Typography color="error">Fehler: {error}</Typography>;

    return (
        <Box>
            <TourGrid loading={loading} tours={ongoingTours} grouped={false} showOwner={true}  />
        </Box>
    );
};